import { render, staticRenderFns } from "./orderList.vue?vue&type=template&id=dd60b078&scoped=true&"
import script from "./orderList.vue?vue&type=script&lang=ts&"
export * from "./orderList.vue?vue&type=script&lang=ts&"
import style0 from "./orderList.vue?vue&type=style&index=0&id=dd60b078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd60b078",
  null
  
)

export default component.exports